import {
  useEffect, useRef, useState
} from 'react';
import useSWR from 'swr';

import { swrOrchestrationListFetcher } from '../api_functions/orchestrationListFetch'
import useWorkspaceContext from '../../components/workspaces/WorkspaceContext/WorkspaceContext';

const useOrchestrationList = () => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);

  const { currentWorkspaceId: workspaceId } = useWorkspaceContext()

  const {
    data, error, isLoading,
  } = useSWR([workspaceId, 'orch-list'], swrOrchestrationListFetcher, { refreshInterval: 3000 })

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    orchestrationData: data,
    error: errorMessage,
    loading: isLoading,
  };
};
export default useOrchestrationList;
